import { ConciergeContext } from '@/providers/concierge';
import { useContext } from 'react';

export function useConcierge() {
    const context = useContext(ConciergeContext);
    if (!context) {
        throw new Error('useConcierge must be used within a ConciergeProvider');
    }
    return context;
}

/**
 * The concierge state, or `undefined` when no ConciergeProvider is mounted.
 * For UI that can render above the provider; everything else should use
 * `useConcierge`.
 */
export function useOptionalConcierge() {
    return useContext(ConciergeContext);
}
